import React, { useState } from "react";

const panData = [
  {
    srNo: 1,
    userId: "Seller7638625",
    userName: "MD Sahnwaj Alam",
    panName: "",
    panNumber: "",
    panDob: "25/03/2022",
    panDate: "25/03/2022",
    panImage: "",
    panStatus: "Reject",
  },
  {
    srNo: 2,
    userId: "Seller5326699",
    userName: "Neha Kushwaha",
    panName: "",
    panNumber: "",
    panDob: "05/03/2022",
    panDate: "05/03/2022",
    panImage: "",
    panStatus: "Reject",
  },
];

const SellerPanDetail = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [type, setType] = useState("");
  const [panList, setPanList] = useState(panData);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted");
    console.log("Start Date:", startDate);
    console.log("End Date:", endDate);
    console.log("Type:", type);
  };

  const handleApproval = (srNo, status) => {
    const updatedList = panList.map((item) =>
      item.srNo === srNo ? { ...item, panStatus: status } : item
    );
    setPanList(updatedList);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>Pan Approval List</h2>
      
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.formGroup}>
          <label style={styles.label}>Sdate</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            required
            style={styles.input}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Edate</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            required
            style={styles.input}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Type</label>
          <select
            value={type}
            onChange={(e) => setType(e.target.value)}
            required
            style={styles.input}
          >
            <option value="">Select Type</option>
            <option value="Type1">Type 1</option>
            <option value="Type2">Type 2</option>
            <option value="Type3">Type 3</option>
          </select>
        </div>
        <button type="submit" style={styles.submitButton}>Submit</button>
      </form>

      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr style={styles.tableHeaderRow}>
              <th style={styles.tableHeader}>Sr No.</th>
              <th style={styles.tableHeader}>User Id</th>
              <th style={styles.tableHeader}>User Name</th>
              <th style={styles.tableHeader}>Pan Name</th>
              <th style={styles.tableHeader}>Pan Number</th>
              <th style={styles.tableHeader}>Pan Dob</th>
              <th style={styles.tableHeader}>Pan Date</th>
              <th style={styles.tableHeader}>Pan Image</th>
              <th style={styles.tableHeader}>Pan Status</th>
              <th style={styles.tableHeader}>Action</th>
            </tr>
          </thead>
          <tbody>
            {panList.map((pan) => (
              <tr key={pan.srNo} style={styles.tableRow}>
                <td style={styles.tableCell}>{pan.srNo}</td>
                <td style={styles.tableCell}>{pan.userId}</td>
                <td style={styles.tableCell}>{pan.userName}</td>
                <td style={styles.tableCell}>{pan.panName}</td>
                <td style={styles.tableCell}>{pan.panNumber}</td>
                <td style={styles.tableCell}>{pan.panDob}</td>
                <td style={styles.tableCell}>{pan.panDate}</td>
                <td style={styles.tableCell}>{pan.panImage}</td>
                <td style={styles.tableCell}>{pan.panStatus}</td>
                <td style={styles.tableCell}>
                  <button
                    onClick={() => handleApproval(pan.srNo, "Approve")}
                    style={styles.approveButton}
                  >
                    Approve
                  </button>
                  <button
                    onClick={() => handleApproval(pan.srNo, "Reject")}
                    style={styles.rejectButton}
                  >
                    Reject
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "1200px",
    margin: "20px auto",
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  },
  header: {
    textAlign: "center",
    fontSize: "24px",
    color: "#2c3e50",
    marginBottom: "20px",
  },
  form: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "15px",
    marginBottom: "30px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: "bold",
    color: "#34495e",
  },
  input: {
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    fontSize: "14px",
    color: "#34495e",
  },
  submitButton: {
    gridColumn: "span 3",
    padding: "10px 15px",
    backgroundColor: "#3498db",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "16px",
    transition: "background-color 0.3s ease",
  },
  submitButtonHover: {
    backgroundColor: "#2980b9",
  },
  tableContainer: {
    overflowX: "auto",
    marginTop: "20px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    borderRadius: "8px",
    overflow: "hidden",
  },
  tableHeaderRow: {
    backgroundColor: "#2c3e50",
    color: "#fff",
  },
  tableHeader: {
    padding: "12px",
    textAlign: "left",
    fontSize: "14px",
  },
  tableRow: {
    backgroundColor: "#f9f9f9",
    transition: "background-color 0.3s ease",
  },
  tableCell: {
    padding: "12px",
    border: "1px solid #ddd",
    fontSize: "14px",
  },
  approveButton: {
    backgroundColor: "#27ae60",
    color: "#fff",
    padding: "6px 12px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
    marginRight: "10px",
    transition: "background-color 0.3s ease",
  },
  rejectButton: {
    backgroundColor: "#e74c3c",
    color: "#fff",
    padding: "6px 12px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s ease",
  },
  approveButtonHover: {
    backgroundColor: "#2ecc71",
  },
  rejectButtonHover: {
    backgroundColor: "#c0392b",
  },
};

export default SellerPanDetail;
